export const LESSON_BUILDER_DEFAULT_CONTEXT = {
  courseTitle: 'Приложение qbeek',
  lessonTitle: 'Авторизация',
  lessonLabel: 'Урок 1',
};

export const LESSON_BUILDER_STATUS_FLAGS = [
  {
    id: 'active',
    enabledTitleKey: 'education.lessonActiveTitle',
    disabledTitleKey: 'education.lessonInactiveTitle',
    enabledDescriptionKey: 'education.lessonActiveDescription',
    disabledDescriptionKey: 'education.lessonInactiveDescription',
    enabled: true,
  },
  {
    id: 'required',
    enabledTitleKey: 'education.lessonRequiredTitle',
    disabledTitleKey: 'education.lessonOptionalTitle',
    enabledDescriptionKey: 'education.lessonRequiredDescription',
    disabledDescriptionKey: 'education.lessonOptionalDescription',
    enabled: true,
  },
];

export const LESSON_BUILDER_STATUS_TEXT_BY_ACTIVITY = {
  lesson: {
    statusTitleKey: 'education.lessonBuilderStatusTitle',
    flags: {
      active: {
        enabledTitleKey: 'education.lessonActiveTitle',
        disabledTitleKey: 'education.lessonInactiveTitle',
        enabledDescriptionKey: 'education.lessonActiveDescription',
        disabledDescriptionKey: 'education.lessonInactiveDescription',
      },
      required: {
        enabledTitleKey: 'education.lessonRequiredTitle',
        disabledTitleKey: 'education.lessonOptionalTitle',
        enabledDescriptionKey: 'education.lessonRequiredDescription',
        disabledDescriptionKey: 'education.lessonOptionalDescription',
      },
    },
  },
  quiz: {
    statusTitleKey: 'education.quizBuilderStatusTitle',
    flags: {
      active: {
        enabledTitleKey: 'education.quizActiveTitle',
        disabledTitleKey: 'education.quizInactiveTitle',
        enabledDescriptionKey: 'education.quizActiveDescription',
        disabledDescriptionKey: 'education.quizInactiveDescription',
      },
      required: {
        enabledTitleKey: 'education.quizRequiredTitle',
        disabledTitleKey: 'education.quizOptionalTitle',
        enabledDescriptionKey: 'education.quizRequiredDescription',
        disabledDescriptionKey: 'education.quizOptionalDescription',
      },
    },
  },
  game: {
    statusTitleKey: 'education.gameBuilderStatusTitle',
    flags: {
      active: {
        enabledTitleKey: 'education.gameActiveTitle',
        disabledTitleKey: 'education.gameInactiveTitle',
        enabledDescriptionKey: 'education.gameActiveDescription',
        disabledDescriptionKey: 'education.gameInactiveDescription',
      },
      required: {
        enabledTitleKey: 'education.gameRequiredTitle',
        disabledTitleKey: 'education.gameOptionalTitle',
        enabledDescriptionKey: 'education.gameRequiredDescription',
        disabledDescriptionKey: 'education.gameOptionalDescription',
      },
    },
  },
};

export const LESSON_BUILDER_MATERIAL_BLOCKS = [
  {
    id: 'image-1',
    type: 'image',
    title: 'Image.png',
    meta: '320 Кб',
    thumbnail: 'mock',
  },
  {
    id: 'text-1',
    type: 'text',
    title: 'Текст',
    description: 'Текст, который является форматированным, как я понимаю из админ панели как раз таки его и форматировали',
  },
  {
    id: 'divider-1',
    type: 'divider',
    title: 'Разделитель',
  },
  {
    id: 'file-1',
    type: 'file',
    title: 'Nameoffile.pdf',
    meta: '333 Кб',
    thumbnail: 'mock',
  },
  {
    id: 'video-1',
    type: 'video',
    title: 'Видео',
    description: 'https://rutube.ru',
  },
  {
    id: 'video-2',
    type: 'video',
    title: 'Видео',
    description: 'https://rutube.ru',
  },
];
